import {
  FOOTER_TONE,
  FooterCopyright,
  FooterDot,
  FooterLegalNav,
} from '@/shared/components/layout';
import { FOOTER_LEGAL } from '@/shared/constants/app/footerNavigation.ts';

/**
 * 사이트 기본 푸터 — 필수 링크 + 사업자 정보 + 카피라이트.
 *
 * 색은 전부 `FOOTER_TONE` 에서 가져온다. 예전에는 `bg-neutral-950` + `text-white/*`
 * 를 그대로 박아둬서 **라이트 모드에서도 검은 덩어리**였다. 헤더·본문은 테마를
 * 따르는데 푸터만 안 따라가면 페이지 끝에서 테마가 끊긴다.
 */
export function Footer() {
  const { company } = FOOTER_LEGAL;

  return (
    <footer
      className={`${FOOTER_TONE.root} ${FOOTER_TONE.edge} px-5 py-12 sm:px-8`}
    >
      <div className="mx-auto max-w-[1440px]">
        <FooterLegalNav />

        {/* 사업자 정보 — 작게 */}
        <div
          className={`mt-7 space-y-1 text-[12px] leading-relaxed ${FOOTER_TONE.meta}`}
        >
          <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1">
            <span className={FOOTER_TONE.metaStrong}>{company.name}</span>
            <FooterDot />
            <span>대표 {company.ceo}</span>
            <FooterDot />
            <span>사업자등록번호 {company.businessNumber}</span>
            <FooterDot />
            <span>통신판매업신고 {company.mailOrderNumber}</span>
          </div>
          <p>주소 {company.address}</p>
          <div className="flex flex-wrap items-center gap-x-2.5 gap-y-1">
            <a
              href={`tel:${company.tel.replace(/-/g, '')}`}
              className={`transition-colors ${FOOTER_TONE.metaLink}`}
            >
              전화 {company.tel}
            </a>
            <FooterDot />
            <a
              href={`mailto:${company.emailEstimate}`}
              className={`transition-colors ${FOOTER_TONE.metaLink}`}
            >
              적산용역 {company.emailEstimate}
            </a>
            <FooterDot />
            <a
              href={`mailto:${company.emailSupport}`}
              className={`transition-colors ${FOOTER_TONE.metaLink}`}
            >
              고객지원 {company.emailSupport}
            </a>
          </div>
        </div>

        <FooterCopyright className="mt-8" />
      </div>
    </footer>
  );
}
